import { useState, useEffect } from "react";
import { AdminField, AdminSaveButton, AdminSection } from "@/admin/AdminComponents";

const CtaEditor = ({ data, onSave, saving }) => {
  const [form, setForm] = useState({});

  useEffect(() => { setForm({ ...data }); }, [data]);

  const update = (key, val) => setForm((p) => ({ ...p, [key]: val }));

  return (
    <div data-testid="cta-editor">
      <AdminSection title="CTA Section" description="Final call-to-action at the bottom of the page">
        <AdminField label="Headline" value={form.headline} onChange={(v) => update("headline", v)} placeholder="Let's Build Something" />
        <AdminField label="Supporting Text" value={form.text} onChange={(v) => update("text", v)} rows={2} />
        <AdminField label="Button Text" value={form.button_text} onChange={(v) => update("button_text", v)} placeholder="Contact Us" />
        <AdminField label="Contact Email" value={form.email} onChange={(v) => update("email", v)} type="email" placeholder="info@mayr-technologies.com" />
      </AdminSection>

      <AdminSaveButton onClick={() => onSave(form)} saving={saving} />
    </div>
  );
};

export default CtaEditor;
